/**
 * @prettier
 */

import { useEffect, useState } from 'react';
import ApiService from 'util/api';

export default function useRelatedDrafts(suiteUUID) {
  const [relatedDrafts, setRelatedDrafts] = useState();

  const fetchRelatedDrafts = () => {
    const url = `/web-api/v2/card-catalog/suites/${suiteUUID}/drafts`;

    if (relatedDrafts) {
      return Promise.resolve(relatedDrafts);
    }

    return ApiService.get(url).then(json => {
      setRelatedDrafts(json);

      return Promise.resolve(json);
    });
  };

  return fetchRelatedDrafts;
}

// refetches drafts if suite uuid changes
export function useRelatedDraftsV2(suiteUUID) {
  const [relatedDrafts, setRelatedDrafts] = useState([]);

  useEffect(() => {
    if (suiteUUID) {
      ApiService.get(`/web-api/v2/card-catalog/suites/${suiteUUID}/drafts`).then(response => {
        setRelatedDrafts(response);
      });
    }
  }, [suiteUUID]);

  return relatedDrafts;
}
